<template>
    <ul class="main-menu list-unstyled d-none d-lg-flex m-0 w-100">
        <li v-for="(item, itemKey) in menuItems" :key="itemKey" class="main-menu-item">
            <a class="top-menu-link" :href="item.url">
                <span v-text="item.name" />
                <FontAwesomeIcon v-if="hasDropdown(item)" icon="chevron-down" class="ml-1 menu-icon" />
            </a>
            <div v-if="hasDropdown(item)" class="sub-menu-wrapper">
                <div v-if="item.columns.length" class="sub-menu">
                    <div class="d-flex sub-menu-columns">
                        <ul v-for="(column, columnKey) in item.columns"
                            :key="columnKey"
                            class="list-unstyled sub-menu-column flex-grow-1"
                        >
                            <!-- left column in 2 columns dropdown-->
                            <li v-for="(child, childKey) in column.children" :key="childKey">
                                <template v-if="columnKey === 0">
                                    <a class="d-flex sub-menu-link"
                                       :href="child.url"
                                    >
                                        <img class="sub-menu-link-icon"
                                             :src="child.icon"
                                             alt=""
                                        >
                                        <div>
                                            <span class="d-block font-weight-bold" v-html="child.name" />
                                            <span class="d-block link-description" v-html="child.description" />
                                        </div>
                                    </a>
                                </template>

                                <!-- right column in 2 columns dropdown-->
                                <template v-else>
                                    <span v-if="childKey === 0"
                                          class="sub-menu-column-title"
                                          v-text="column.title"
                                    />
                                    <a v-else
                                       class="d-flex sub-menu-link"
                                       :href="child.url"
                                       v-html="child.name"
                                    />
                                </template>
                            </li>
                        </ul>
                    </div>
                </div>
                <ul v-else class="sub-menu list-unstyled">
                    <li v-for="(child, childKey) in item.children" :key="childKey">
                        <a v-if="child.url"
                           class="d-flex sub-menu-link"
                           :href="child.url"
                        >
                            <img class="sub-menu-link-icon"
                                 :src="child.icon"
                                 alt=""
                            >
                            <div>
                                <span class="d-block font-weight-bold" v-html="child.name" />
                                <span class="d-block link-description" v-html="child.description" />
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </li>
    </ul>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faChevronRight, faChevronDown);

export default {
    components: { FontAwesomeIcon },
    props: {
        menuItems: {
            type: Array,
            required: true,
        },
    },
    methods: {
        hasDropdown(item) {
            return item.columns.length || item.children.length;
        },
    },
};
</script>

<style lang="scss" scoped>
.main-menu {
    min-height: 4rem;
    line-height: 1.8;
    gap: 1.65rem;
}

.sub-menu-wrapper {
    display: none;
    position: absolute;
    height: 1.5rem;
    width: calc(100% + 10px);
    z-index: 1000;
}

.main-menu-item:hover {
    .sub-menu-wrapper {
        display: block;
    }
}

.sub-menu {
    position: relative;
    top: 1rem;
    background: #fff;
    width: max-content;
    border: 1px solid transparent;
    border-radius: 1rem;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2), 0 8px 16px 0 rgba(0, 0, 0, 0.05);

    &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 3.5rem;
        border: 0.3rem solid;
        border-color: transparent transparent #fff #fff;
        transform-origin: 0 0;
        transform: rotate(135deg);
        box-sizing: border-box;
        box-shadow: -3px 3px 3px 0 rgba(0, 0, 0, 0.05);
    }

    li {
        margin-left: -0.5px;
        margin-right: -0.5px;
    }

    li:first-of-type {
        margin-top: 1.5rem;
    }

    li:last-of-type {
        margin-bottom: 1.5rem;
    }

    li:not(:last-of-type) {
        margin-bottom: 0.75rem;
    }

    .sub-menu-link {
        padding: 0.875rem 1.625rem;
    }
}

.sub-menu-link:hover {
    background-color: #F7F9FC;
    text-decoration: none;
}

.sub-menu {
    .sub-menu-columns {
        .sub-menu-column:nth-child(1) a:not(:last-of-type) {
            margin-bottom: 0.75rem;
        }

        .sub-menu-column:nth-child(2) {
            background-color: #F7F9FC;
            white-space: nowrap;
            padding: 2rem 1.5rem 1.5rem;
            margin-top: -0.5px;
            margin-right: -0.5px;
            margin-bottom: -0.5px;
            border-top-right-radius: 1rem;
            border-bottom-right-radius: 1rem;

            li {
                margin: 0;
            }

            .sub-menu-link {
                font-size: 0.875rem;
                padding: 0.375rem 0.625rem;

                &:hover {
                    opacity: 0.7;
                }
            }

            .sub-menu-column-title {
                color: #707DA7;
                text-transform: uppercase;
                font-size: 0.75rem;
                font-weight: bold;
                padding: 0 0.625rem;
            }
        }
    }
}

.sub-menu-link-icon {
    max-width: 3rem;
    max-height: 3rem;
    margin-right: 1.25rem;
}

.link-description {
    font-size: 0.85rem;
    line-height: 1.25rem;
    white-space: nowrap;
}

.top-menu-link, .sub-menu-link {
    color: #15204F;
}

.top-menu-link {
    display: block;
    line-height: 3.75rem;

    &:hover {
        text-decoration: none;
    }
}

.menu-icon {
    font-size: 0.625rem;
}
</style>
